import React from 'react';
import eIcon from '../../../assets/img/event-imgs/e-plus.svg';
import blogImage from '../../../assets/img/blog-imgs/blog-image1.png';
import userImage from '../../../assets/img/blog-imgs/blog-userpic1.svg';
import starIcon from '../../../assets/img/gigs-imgs/star.svg';

const ShowGigs = () => {
    const gigsDatas = [
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "ddd In pulvinar libero eu puru vehicula, et...",
            authorName: "Maruf Richard",
            authorImage: userImage,
            avarageRating: 4.3,
            retingPeoples: 450,
            hourlyPrice: "$59"
        },
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "bbb In pulvinar libero eu puru vehicula, et...",
            authorName: "Mobin Richard",
            authorImage: userImage,
            avarageRating: 2.3,
            retingPeoples: 50,
            hourlyPrice: "$59"
        },
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "aaa In pulvinar libero eu puru vehicula, et...",
            authorName: "Rafi Bhai",
            authorImage: userImage,
            avarageRating: 3.3,
            retingPeoples: 350,
            hourlyPrice: "$59"
        },
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "sdf In pulvinar libero eu puru vehicula, et...",
            authorName: "Manoj bhai",
            authorImage: userImage,
            avarageRating: 3,
            retingPeoples: 250,
            hourlyPrice: "$59"
        },
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "s In pulvinar libero eu puru vehicula, et...",
            authorName: "Shafin bhai",
            authorImage: userImage,
            avarageRating: 4.5,
            retingPeoples: 250,
            hourlyPrice: "$59"
        },
        {
            gigThumbnail: blogImage,
            gigTag: "Fitness",
            gigDesc: "sdf In pulvinar libero eu puru vehicula, et...",
            authorName: "Shobna mam",
            authorImage: userImage,
            avarageRating: 4,
            retingPeoples: 20,
            hourlyPrice: "$59"
        },
    ]
    return (
        <div className='row gy-4'>
            {
                gigsDatas.map(( item, index ) =>  <div className="col-12 col-md-6 col-xxl-4" key={index}> 
                    <div className="card" style={{backgroundColor: "#171717", borderRadius: "20px",borderStyle: "none"}}>
                        <div className="position-relative">
                            <button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor: "#00000041", borderStyle: "none", right: "4%", bottom: "4%"}}>
                            <img src={eIcon} alt="" />
                            </button>
                            <img className="w-100" src={item.gigThumbnail} style={{borderRadius: "20px 20px 0px 0px"}} alt="" />
                        </div>
                        <div className="w-100" style={{height: "4px", background: "linear-gradient(90deg, #B402F6, #40EEFE)"}}></div>
                        <div className="card-body">
                            <div className="row gap-2">
                                <div className="col-12">
                                    <span className="b_dt">{item.gigTag}</span>
                                </div>
                                <div className="col-12">
                                    <span className="txt_wa">{item.gigDesc}</span>
                                </div>
                                <div className="col-12">
                                    <img className="me-1" src={item.authorImage} alt="" />
                                    <span className="txt_name">{item.authorName}</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-100" style={{height: "1px", background: "#3E3E3E"}}></div>
                        <div className="card-body">
                            <div className="row gap-2">
                                <div className="col-12 d-flex justify-content-between align-items-center">
                                    <div className="d-flex justify-content-center align-items-center gap-1">
                                        <img src={starIcon} alt="" />
                                        <span className="b_dt">{item.avarageRating}</span>
                                        <span className="s_ur">{item.retingPeoples}</span>
                                    </div>
                                    <div>
                                        <span className="e_bdt me-1">FROM</span>
                                        <span className="txt_wa">{item.hourlyPrice}</span>
                                        <span className="l_untxt">/hr</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>)
            }
        </div>
    );
};

export default ShowGigs;